@if (isPaid) {
  <div class="grid-x receipt-border">
    <div class="cell small-12 medium-12 large-12">
      <h2 class="receipt-header-confirmation">Payment Confirmation</h2>
    </div>
    <div [id]="getDocumentId('Receipt')" style="width: 100%;">
      <table style="table-layout: fixed; width: 100%; border-collapse: separate; border-spacing: 0px 5px">
        <caption>Receipt for Application # {{applicationNumber}}</caption>
        <thead style="background-color: #fdfdfd;">
          <tr>
            <td style="width: 65%;"></td>
            <td style="width: 35%;"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" style="background-color: #dddddd; font-weight: bold; padding: 10px 0px 10px 1rem; font-size: 14px; line-height: 14px">
              Receipt for Application # {{applicationNumber}}
            </td>
          </tr>
          <tr>
            <td colspan="2" style="background-color: #dddddd; line-height: 14px; font-size: 14px; font-weight: bold; padding: 10px 0px 10px 1rem;">
              Owner: {{organizationId}} - {{organizationName}}
            </td>
          </tr>
          <tr style="background-color: #fdfdfd;">
            <td colspan="2" style="padding-left: 1rem;">
              <div style="font-weight: bold; float: left; padding-right: 10px;">Payment Type@if (paymentTypes.length > 1) {
                s
              }:</div>
              <div style="float: left;">
                @for (pmt of getDisplayTokens(paymentTypes); track pmt) {
                  @if (pmt.instrumentType === 'Cash') {
                    Cash in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2' }} <br />
                  }
                  @if (pmt.instrumentType === 'Check') {
                    Check {{pmt.instrumentToken}} in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2' }} @if (pmt.appliedAmount !== 0) {
                    <span>- {{ pmt.appliedAmount | currency: 'USD':'symbol':'1.2-2'}} applied</span>
                    } <br />
                  }
                  @if (pmt.instrumentType === 'Money Order') {
                    Money Order {{pmt.instrumentToken}} in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2' }} @if (pmt.appliedAmount !== 0) {
                    <span>- {{ pmt.appliedAmount | currency: 'USD':'symbol':'1.2-2'}} applied</span>
                    } <br />
                  }
                  @if (pmt.instrumentType === 'Credit') {
                    Credit Authorization {{pmt.instrumentToken}} in the amount of {{ pmt.instrumentAmount | currency: 'USD':'symbol':'1.2-2'}} @if (pmt.appliedAmount !== 0) {
                    <span>- {{pmt.appliedAmount | currency: 'USD':'symbol':'1.2-2'}} applied</span>
                    } <br />
                  }
                }
              </div>
            </td>
          </tr>
          <tr style="background-color: #fdfdfd;">
            <td colspan="2" style="padding-left: 1rem;">
              {{organizationName}}
            </td>
          </tr>
          <tr style="background-color: #fdfdfd;">
            <td colspan="2" style="text-align: left; font-weight: bold; padding: 0 1rem;">
              Description:
            </td>
          </tr>
          @for (source of adjustmentSources; track source) {
            <tr style="background-color: #fdfdfd;">
              <td colspan="2">
                <adjustment-view [applicationNumber]="applicationNumber" [adjustment]="source"  [requestedDate]="requestedDate" ></adjustment-view>
              </td>
            </tr>
          }
          @for (payment of records; track payment) {
            <tr style="background-color: #fdfdfd;">
              <td style="padding-left: 1rem; white-space: nowrap; overflow: hidden; vertical-align: bottom; font-size: 1rem;">
                {{payment.description}}@if (payment.instrumentType !== 'Credit') {
                (reference # {{payment.id}})
                }{{filler}}
              </td>
              <td style="padding-right: .5rem; white-space: nowrap; text-align: right; direction: rtl; overflow: hidden; vertical-align: bottom;" [ngStyle]="{ 'font-size': (shrinkFont) ? '.7rem': 'inherit' }">
                <span style="font-weight: bold;">
                  Fee:
                </span>
                {{ payment.fee | currency: 'USD': symbol: '1.2-2'}} - <span style="font-weight: bold;">Paid:</span> <span [ngStyle]="{ 'font-style': (payment.paymentStatus === 'Partial') ? 'italic' : 'normal'}"> {{payment.amountPaid | currency: 'USD': 'symbol': '1.2-2'}}</span>{{filler}}
              </td>
            </tr>
          }
        </tbody>
        <tfoot style="background-color: #fdfdfd; border-collapse: collapse;">
          <tr>
            <td colspan="2" style="padding: 5px 0 5px 0; text-align: right; font-weight: bold; border-top: solid 1px black;">Total Due: {{ totalDue }}</td>
          </tr>
          <tr>
            <td colspan="2" style="padding: 5px 0 5px 0; text-align: right; font-weight: bold; ">Total Paid: {{totalPaid}}</td>
          </tr>
          <tr>
            <td colspan="2" style="padding: 5px 0 5px 0; text-align: right; font-weight: bold; border-top: solid 1px black;" [ngStyle]="{ 'font-style': (totalPaid !== totalDue) ? 'italic': 'normal' }">Remaining Due: {{remainingDue}}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
} @else {
  <div class="receipt-border">
    <div style="width: 100%; display: flex; flex-direction: row;">
      <div style="flex-grow: 1; text-align: left;">
        <h2>Amount Invoiced</h2>
      </div>
    </div>
    <div [id]="getDocumentId('Invoice')">
      <table style="table-layout: fixed; width: 100%; border-collapse: separate; border-spacing: 0px 5px;">
        <caption>Invoice for Application #: {{applicationNumber}}</caption>
        <thead style="background-color: #fdfdfd;">
          <tr>
            <td style="width: 80%;"></td>
            <td style="width: 20%;"></td>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color: #dddddd; font-size: 14px; font-weight: bold; padding: 2px 0px 2px 1rem;">
            <td colspan="2">
              Invoice for Application #: {{applicationNumber}}
            </td>
          </tr>
          @if (records && records.length > 0) {
            <tr style="background-color: #dddddd; font-size: 14px; font-weight: bold; padding: 2px 0px 2px 1rem;">
              <td colspan="2">
                Owner: {{organizationId}} - {{organizationName}}
              </td>
            </tr>
          }
          @for (source of adjustmentSources; track source) {
            <tr style="background-color: #fdfdfd;">
              <td colspan="2">
                <adjustment-view [applicationNumber]="applicationNumber" [adjustment]="source"  [requestedDate]="requestedDate"></adjustment-view>
              </td>
            </tr>
          }
          @for (payment of records; track payment) {
            <tr style="padding: 5px 0px 5px 1rem; background-color: #fdfdfd;">
              <td style="white-space: nowrap; overflow: hidden;">{{payment.description}} (reference #{{payment.id}}){{filler}}</td>
              <td style="padding-right: 0px; white-space: nowrap; text-align: right; direction: rtl; overflow: hidden;">{{payment.fee | currency: 'USD':'symbol':'1.2-2'}}{{filler}}</td>
            </tr>
          }
        </tbody>
        <tfoot style="background-color: #fdfdfd;">
          <tr>
            <td colspan="2" style="padding: 10px 0 5px 0; text-align: right; font-weight: bold; border-top: solid 1px black;">Total: {{ totalDue }}</td>
          </tr>
          <tr>
            <td colspan="2" style="font-size: .7rem; width: 100%; text-align: right;">
              **Please include the application number and applicable reference number(s) for the above payments when remitting payment(s).**
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
}


